import { types, flow, getEnv } from 'mobx-state-tree'
import { ModelStore } from '../core/model-store'
import { Model, MODEL_NAME } from './model'

const API_URL = '/policies'

export const Store = ModelStore.named(`${MODEL_NAME}Store`)
  .props({
    url: API_URL,
    map: types.map(Model),
    currentEndpoint: types.optional(types.string, ''),
  })
  .actions((self) => ({
    getClient() {
      return getEnv(self).client
    },
    
    fetchAll: flow(function* fetchAll(options) {
      const requestUrl = options?.customUrl || self.url
      
      if (self.currentEndpoint !== requestUrl) {
        self.clear()
        self.currentEndpoint = requestUrl
      }
      
      self.loading = true
      
      try {
        const response = yield getEnv(self).client.get(requestUrl, {
          action: `fetchAll${self.modelName}`,
          ...options,
        })
        
        if (response) {
          self.putIncluded(response.data?.included)
          self.putItems(response.data?.data, requestUrl)
          return Array.from(self.map.values())
        }
      } catch (error) {
        console.error(`Error fetching ${self.modelName}s:`, error)
        if (options?.throwError) {
          throw error
        }
      } finally {
        self.loading = false
      }
    })
  }))

export default Store
